import gql from 'graphql-tag'

export const SUBSCRIBE_USERS = gql`
subscription {
 users (order_by: {name: asc}){
    id
    name
    email
    mobile
    role
    password
    userCities{ userId city }
    isActive
    }
  }
 `
